import { useState } from 'react';
import * as M from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useParams, useSearchParams } from 'react-router-dom';

import { useGetManuals } from '../../../../../../shared/apis/ai-agent/manual/reactQueries';
import * as C from '../../../../../ui/common/CommonStyles';
import AiAgentTabs from '../../Common/ui/AiAgentTabs';
import useAiAgentManualFilters from './hooks/useAiAgentManualFilters';
import AiAgentManualFilterSection from './ui/filterSection';
import ManualFileUploadModal from './ui/manualFileUploadModal';
import ManualListTable from './ui/manualListTable';
import ManualModelMappingModal from './ui/manualModelMappingModal';
import { useGetCompanyDetails } from '../../../../../../shared/apis/company/reactQueries';
import {
  isProdoqAiAgentEnabled,
  isProgixAiAgentEnabled,
  isScautrAiAgentEnabled,
} from '../../../../../../shared/utils/aiAgentServiceChannel';

export default function AiAgentManual() {
  const { companyId } = useParams();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || '';
  const [selectedFileUploadId, setSelectedFileUploadId] = useState<number | null>(null);
  const {
    filterForm,
    queryParams,
    modelOptions,
    searchType,
    inputRef,
    onPageChange,
    updateFilterForm,
    handleSearchType,
    handleSearch,
    resetSearchInput,
    resetFilters,
  } = useAiAgentManualFilters(Number(companyId));
  const [openedMappingModal, { open: openMappingModal, close: closeMappingModal }] = useDisclosure(false);
  const [openedFileUploadModal, { open: openFileUploadModal, close: closeFileUploadModal }] = useDisclosure(false);

  const onClickOpenMappingModal = (fileUploadId: number) => {
    setSelectedFileUploadId(fileUploadId);
    openMappingModal();
  };

  const onClickOpenFileUploadModal = () => {
    openFileUploadModal();
  };

  const { data: manuals } = useGetManuals(queryParams);

  const { data: companyDetails } = useGetCompanyDetails({
    companyId: Number(companyId),
  });

  const scautrAiAgentEnabled = isScautrAiAgentEnabled(companyDetails?.channels);
  const progixAiAgentEnabled = isProgixAiAgentEnabled(companyDetails?.channels);
  const prodoqAiAgentEnabled = isProdoqAiAgentEnabled(companyDetails?.channels);

  return (
    <div>
      {/* <C.TitleBox>
        <div className="title">AI Agent 서비스 관리</div>
      </C.TitleBox> */}
      <C.ListBox>
        <M.Stack gap="lg">
          <M.Flex
            gap="md"
            align="center"
            justify="space-between"
            style={(theme) => ({
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: theme.colors.gray[0],
              borderRadius: theme.radius.sm,
              padding: theme.spacing.sm,
            })}
          >
            <M.Box>
              <M.Text size="xs" c="gray.6">
                거래처명
              </M.Text>
              <M.Text fw={500}>{companyName}</M.Text>
            </M.Box>
          </M.Flex>
          <AiAgentTabs />
          <AiAgentManualFilterSection
            filterForm={filterForm}
            modelOptions={modelOptions}
            searchType={searchType}
            inputRef={inputRef}
            onChangeFilterForm={updateFilterForm}
            onChangeSearchType={handleSearchType}
            handleSearch={handleSearch}
            resetSearchInput={resetSearchInput}
            onReset={resetFilters}
          />
          <ManualListTable
            servicesEnabled={{
              scautr: scautrAiAgentEnabled,
              progix: progixAiAgentEnabled,
              prodoq: prodoqAiAgentEnabled,
            }}
            data={manuals}
            page={Number(queryParams.page) ?? 1}
            size={Number(queryParams.size) ?? 10}
            onPageChange={onPageChange}
            openMappingModal={onClickOpenMappingModal}
            openFileUploadModal={onClickOpenFileUploadModal}
          />
          {openedMappingModal && (
            <ManualModelMappingModal
              opened={openedMappingModal}
              onClose={closeMappingModal}
              fileUploadId={selectedFileUploadId}
            />
          )}
          {openedFileUploadModal && <ManualFileUploadModal opened={openedFileUploadModal} onClose={closeFileUploadModal} />}
        </M.Stack>
      </C.ListBox>
    </div>
  );
}
